export default "__VITE_ASSET__CAuJBiAS__"